import React from 'react'
import { FireFilled } from '@ant-design/icons'
import { GeneralTitle } from '../../../components/Shared'
import { Card, Space } from 'antd'
import InRow from '../../../components/Power/InRow'
import Presentation from '../../../components/Power/Presentation'
import CustomWrapper from '../../../components/Shared/CustomWrapper'
import { GeneralParagraph } from '../../../components/Shared/GeneralComponents'
import { stripeCheckoutPlanMetaId } from '../../../stores/subscriptions/actions'

/* ========== PAGE COMPOSITION FOR CURRENT USAGE ========== */
const sectionFullWidthStyle = {
	width: '100%',
	marginLeft: '-30px',
	marginRight: '-30px',
	padding: '30px 30px',
	boxSizing: 'unset'
}
const AiWpPublicChat = () => {
	const buttons = [
		{
			id: 'cta1',
			key: 'cta1',
			type: 'primary',
			onClick: () => {
				stripeCheckoutPlanMetaId('ai-wp-public-chat-starter')
			},
			label: 'Starter • €10/mo',
			loginRequired: {
				onLoggedIn: () => console.log('Logged in'),
				target: 'cta1',
				action: 'onClick'
			},
			style: {
				padding: '30px',
				fontWeight: '600',
				border: 'unset'
			},
			ghost: true,
			textEffect: 'scramble',
			textEffectProps: {
				duration: 300,
				scrambleOn: 'hover' // or 'hover' or 'viewport'
			},
			wrapper: (btn) => (
				<CustomWrapper
					style={{
						borderRadius: 8
					}}
					color="var(--c-13-d)"
					colorHover="var(--c-13-l)"
					bgColors={['var(--c-13-l)']}
					bgColorsHover={['var(--c-13-d)']}
					// glow="var(--c-11-d)"
					// glowHoverColor="var(--c-11-l)"
					// glowBlur={0}
					// glowSpread={0}
					// glowHoverBlur={0}
					// glowHoverSpread={0}
					// glowOffsetY={5}
					// glowOffsetX={8}
					// glowHoverOffsetY={-5}
				>
					{btn}
				</CustomWrapper>
			)
		},
		{
			id: 'cta2',
			key: 'cta2',
			type: 'primary',
			onClick: () => {
				stripeCheckoutPlanMetaId('ai-wp-public-chat-shop')
			},
			// href: '/subscribe?product=ai-wp-public-assistant-shop',
			label: 'Shop • €25/mo',
			loginRequired: {
				onLoggedIn: () => console.log('Logged in'),
				target: 'cta2',
				action: 'onClick'
			},
			style: {
				padding: '30px',
				fontWeight: '600',
				border: 'unset'
			},
			ghost: true,
			textEffect: 'scramble',
			textEffectProps: {
				duration: 300,
				scrambleOn: 'hover' // or 'hover' or 'viewport'
			},
			wrapper: (btn) => (
				<CustomWrapper
					style={{
						borderRadius: 8
					}}
					color="var(--c-brand-d)"
					colorHover="var(--c-brand-l)"
					borderWidth={2}
					bgColors={['var(--c-brand-l)']}
					bgDegree={90}
					bgColorsHover={['var(--c-brand-d)']}
					// glow="var(--c-13-d)"
					// glowHoverColor="var(--c-13-l)"
					// glowBlur={0}
					// glowSpread={0}
					// glowHoverBlur={0}
					// glowHoverSpread={0}
					// glowOffsetY={5}
					// glowOffsetX={8}
					// glowHoverOffsetY={-5}
					orbit={false}
					orbitElement={
						<FireFilled
							style={{
								color: 'var(--c-13-d)',
								fontSize: 15
							}}
						/>
					}
					orbitInset={-6}
					orbitSpeed="3s"
				>
					{btn}
				</CustomWrapper>
			)
		}
	]

	return (
		<>
			{/* <CustomButtonShowcase />
			<Spacer size={100} />
			<CustomWrapperShowcase />
			 */}

			<Space direction="vertical" size={100} style={{ width: '100%' }}>
				<CustomWrapper
					fullWidth
					color="#fff"
					colorHover="#000"
					bgColorsHover={['var(--c-brand-l)']}
					bgColors={['#000']}
					bgAnimate
					style={{
						borderRadius: 10,
						padding: '200px 0'
					}}
				>
					<GeneralTitle
						textEffect="typing"
						textEffectProps={{ speed: 50 }}
						style={{
							textTransform: 'uppercase',
							fontWeight: '900',
							fontSize: 60,
							textAlign: 'center',
							marginBottom: 0,
							fontFamily: 'Anton',
							letterSpacing: '2px'
						}}
					>
						AI{' '}
						<span style={{ color: 'var(--c-brand-d)' }}>
							WordPress
						</span>{' '}
						Public Chat
					</GeneralTitle>

					<GeneralParagraph
						className="wbk-anim-slide-in-bottom"
						style={{
							'--wbk-animation-duration': '2s',
							'--wbk-animation-distance': '200px',
							transform: 'translateY(-10px)',
							textAlign: 'center',
							marginTop: 0,
							fontSize: 18,
							fontWeight: '700'
							// color: '#000'
						}}
					>
						Turn traffic into bookings & sales
					</GeneralParagraph>
				</CustomWrapper>

				<InRow gutter={[50, 50]} align="middle">
					<Presentation
						size={20}
						title={[
							'Convert more visitors',
							{
								level: 2,
								style: {
									margin: 0,
									color: '#000',
									fontWeight: '900'
									// fontFamily: 'Anton'
								}
							}
						]}
						description={[
							'Launch your AI-powered WordPress assistant in minutes. Instantly book meetings and guide shoppers to the right products. No coding needed.',
							{
								style: {
									fontSize: 16,
									margin: 0
								}
							}
						]}
						bullets={[
							[
								'Install in 5 minutes',
								'Works with any theme or builder',
								'GDPR-ready consent and retention',
								'Book only valid time slots',
								'Recommend 2–3 products based on context'
							],
							{},
							[
								{
									iconProps: {
										style: {
											color: 'var(--c-11-d)'
										}
									}
								},
								{
									iconProps: {
										style: {
											color: 'var(--c-11-d)'
										}
									}
								},
								{
									iconProps: {
										style: {
											color: 'var(--c-11-d)'
										}
									}
								},
								{
									iconProps: {
										style: {
											color: 'var(--c-11-d)'
										}
									}
								},
								{
									iconProps: {
										style: {
											color: 'var(--c-13-d)'
										}
									}
								}
							]
						]}
						buttons={[buttons]}
					/>
					<CustomWrapper
						fullWidth
						borderColors={['#000', 'var(--c-brand-d)']}
						style={{ borderRadius: 10, padding: 10 }}
					>
						<Presentation
							video={[
								'path',
								{
									demo: true,
									caption:
										'See how a meeting is booked in 3 clicks',
									style: {
										borderRadius: 10,
										// background: 'unset',
										color: '#000'
									}
								}
							]}
						/>
					</CustomWrapper>
				</InRow>

				<CustomWrapper
					fullWidth
					// color="#fff"
					// bgColorsHover={['#000', '#000']}
					bgColors={['#000', 'var(--c-brand-d)']}
					bgAnimate
					style={{
						...sectionFullWidthStyle,
						marginBottom: -50
					}}
				>
					<Presentation
						title={[
							'Bookings & sales',
							{
								textEffect: 'typing',
								textEffectProps: { speed: 50 },
								style: {
									fontWeight: '900',
									margin: 0,
									color: '#fff'
								}
							}
						]}
						description={[
							[
								'Static forms cannot react to intent. The assistant responds in seconds, clarifies questions and offers valid booking slots based on your schedule',
								'In commerce, it narrows options to a short list with clear reasons so users decide faster and with confidence.'
							],
							{
								className: 'wbk-anim-slide-in-right',
								style: {
									'--wbk-animation-duration': '2s',
									'--wbk-animation-distance': '200px',
									color: '#fff',
									fontSize: 16,
									fontWeight: '500',
									margin: 0
								}
							}
						]}
						image={[
							'path',
							{
								demo: true,
								caption:
									'Real results: More bookings, faster responses'
							}
						]}
					/>
				</CustomWrapper>

				<Presentation
					style={sectionFullWidthStyle}
					title={[
						'Real business use cases',
						{
							level: 2,
							style: {
								marginBottom: 0,
								fontWeight: '900'
							}
						}
					]}
					image={[
						'path',
						{
							demo: true,
							caption: 'Real business use cases'
						}
					]}
					tabs={[
						[
							{
								key: 'clinic',
								tab: 'Clinic',
								content: (
									<Card style={{ borderRadius: 16 }}>
										<Presentation
											size={20}
											description={[
												'Convert visitors into appointments while answering insurance and procedure questions.',
												{
													className:
														'wbk-anim-slide-in-right',
													style: {
														'--wbk-animation-duration':
															'2s',
														'--wbk-animation-distance':
															'200px'
													}
												}
											]}
											timeline={[
												[
													{
														role: 'Customer',
														text: 'Can I book a consultation for next Wednesday afternoon?'
													},
													{
														role: 'Assistant',
														text: 'Available times: 14:00, 15:30, 17:00 (Europe/Bucharest). What works for you?'
													},
													{
														role: 'Customer',
														text: '15:30 is fine.'
													},
													{
														role: 'Assistant',
														text: 'Booked for Wed 15:30. Confirmation email sent. You can reschedule from the link provided.'
													},
													{
														role: 'Customer',
														text: 'Do you accept private insurance X?'
													},
													{
														role: 'Assistant',
														text: 'Yes. We accept X and Y. Bring your card and ID to the visit.'
													}
												],
												{
													circleColor: (entry) =>
														entry.role ===
														'Assistant'
															? 'blue'
															: 'gray'
												}
											]}
										/>
									</Card>
								)
							},
							{
								key: 'shop',
								tab: 'Shop',
								content: (
									<Card style={{ borderRadius: 16 }}>
										<Presentation
											size={20}
											description="Reduce choice overload and guide to in-stock products that fit user constraints."
											timeline={[
												[
													{
														role: 'Customer',
														text: 'I need winter tyres for a VW Golf, mostly city driving, budget friendly.'
													},
													{
														role: 'Assistant',
														text: 'Based on 205/55 R16 and city use, here are 3 options with good wet grip and low noise. Want the top pick or compare all 3?'
													},
													{
														role: 'Customer',
														text: 'Top pick please.'
													},
													{
														role: 'Assistant',
														text: 'Model A fits 205/55 R16, strong wet grip, lowest noise in class. In stock at 4 units. Add to cart or view details?'
													}
												],
												{
													circleColor: (entry) =>
														entry.role ===
														'Assistant'
															? 'blue'
															: 'gray'
												}
											]}
										/>
									</Card>
								)
							},
							{
								key: 'b2b',
								tab: 'B2B Services',
								content: (
									<Card style={{ borderRadius: 16 }}>
										<Presentation
											size={20}
											description="Qualify leads and secure intro calls based on scope and capacity."
											timeline={[
												[
													{
														role: 'Customer',
														text: 'Do you build custom WordPress plugins and when can we talk?'
													},
													{
														role: 'Assistant',
														text: 'Yes, we build custom plugins and integrations. Earliest intro slots: Thu 10:00 or Fri 13:30. Which works?'
													},
													{
														role: 'Customer',
														text: 'Friday.'
													},
													{
														role: 'Assistant',
														text: 'Booked Fri 13:30. I can also send a short checklist to pre-qualify the project.'
													}
												],
												{
													circleColor: (entry) =>
														entry.role ===
														'Assistant'
															? 'blue'
															: 'gray'
												}
											]}
										/>
									</Card>
								)
							}
						]
					]}
				/>

				<Space direction="vertical" size={10} style={{ width: '100%' }}>
					<CustomWrapper
						fullWidth={true}
						color="#fff"
						// bgColorsHover={['#000', '#000']}
						bgColors={['#000', 'var(--c-brand-d)']}
						bgAnimate
						style={{
							...sectionFullWidthStyle
							// padding: '30px'
						}}
					>
						<Presentation
							title={[
								'Go live in 5 minutes',
								{
									textEffect: 'typing',
									textEffectProps: { speed: 50 }
								}
							]}
							image={[
								'path',
								{
									demo: true,
									caption: 'Easy setup: shortcode or block'
								}
							]}
						/>

						<Presentation
							steps={[
								[
									{
										t: 'Download & Install',
										d: 'WP Admin → Plugins → Add New → Upload ZIP.'
									},
									{
										t: 'Activate & Connect',
										d: 'Paste your token, set language and site URL.'
									},
									{
										t: 'Configure Hours',
										d: 'Choose active days and booking slot windows.'
									},
									{
										t: 'Embed the Chat',
										d: 'Use block or shortcode on any public page.'
									}
								],
								{
									direction: 'horizontal'
								},
								{
									className: 'steps-override',
									style: {
										'--ant-steps-item-icon--background-color':
											'#ffffff4f',
										'--ant-steps-item-title': '#ffffff',
										'--ant-steps-item-description':
											'#ffffffdd',
										'--ant-steps-icon--color': '#ffffff',
										'--ant-steps-item-description--max-width':
											'none',
										'--ant-steps-item-title-after--bg':
											'#ffffff69'
									}
								}
							]}
						/>
					</CustomWrapper>
				</Space>

				<Space direction="vertical" size={10} style={{ width: '100%' }}>
					<GeneralTitle
						level={2}
						text="Choose Your Plan & Start Growing"
						style={{
							fontSize: 30,
							fontWeight: '900',
							marginTop: 0
						}}
					/>
					<InRow gutter={[30, 30]}>
						<CustomWrapper
							fullWidth
							borderColors={['#000', 'var(--c-11-d)']}
							borderColorsHover={['var(--c-11-d)']}
							animate
							style={{ borderRadius: 10, padding: 30 }}
						>
							<Space
								direction="vertical"
								size={20}
								style={{ width: '100%' }}
							>
								<GeneralTitle
									level={3}
									text="AI WordPress Public Assistant :: Starter"
									style={{
										fontSize: 18
									}}
								/>
								<Presentation
									key="starter"
									description={[
										'Book meetings and answer company questions.',
										{
											className:
												'wbk-anim-slide-in-right',
											style: {
												'--wbk-animation-duration':
													'2s',
												'--wbk-animation-distance':
													'100px'
											}
										}
									]}
									bullets={[
										[
											'Built-in booking database',
											'Business hours Mon-Sat and minute slots',
											'Timezone-aware confirmations and reminders',
											'Company info and FAQs with quick answers',
											'Analytics for chats and bookings'
										],
										{
											className: 'wbk-anim-slide-in-left',
											style: {
												'--wbk-animation-duration':
													'2s',
												'--wbk-animation-distance':
													'200px'
											}
										},
										{
											iconProps: {
												style: {
													color: 'var(--c-11-d)'
												}
											}
										}
									]}
									buttons={[[buttons[0]]]}
								/>
							</Space>
						</CustomWrapper>
						<CustomWrapper
							fullWidth
							borderColors={['#000', 'var(--c-brand-d)']}
							borderColorsHover={['var(--c-brand-d)']}
							animate
							style={{ borderRadius: 10, padding: 30 }}
						>
							<Space
								direction="vertical"
								size={20}
								style={{ width: '100%' }}
							>
								<GeneralTitle
									level={3}
									text="AI WordPress Public Assistant :: Shop"
									style={{
										fontSize: 18
									}}
								/>
								<Presentation
									key="shop"
									description={[
										'Everything in Starter + AI product recommendations.',
										{
											className:
												'wbk-anim-slide-in-right',
											style: {
												'--wbk-animation-duration':
													'2s',
												'--wbk-animation-distance':
													'100px'
											}
										}
									]}
									bullets={[
										[
											'Recommends by up to 5 product attributes',
											'In-chat product cards and quick-add links',
											'Optional stock and price awareness via your endpoints',
											'Compare 2-3 items with short reasons',
											'Tracks view to click to purchase'
										],
										{
											className:
												'wbk-anim-slide-in-right',
											style: {
												'--wbk-animation-duration':
													'2s',
												'--wbk-animation-distance':
													'200px'
											}
										},
										{
											iconProps: {
												style: {
													color: 'var(--c-brand-d)'
												}
											}
										}
									]}
									buttons={[[buttons[1]]]}
								/>
							</Space>
						</CustomWrapper>
					</InRow>
				</Space>
			</Space>
		</>
	)
}

export default AiWpPublicChat
